import * as React from 'react';
import { withStyles } from '@material-ui/core';
import SearchBox from '../SearchBox';
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';
import ExportCsvButton from '@dataGrid/components/ExportCsvButton';
import FullScreen from '../../../layout/layoutHeader/components/FullScreen';
import ShowHideColumns from '../../../layout/layoutHeader/showHideColumns';
import { withUserProfile } from '../../../userProfile/userProfileContext';
import { GridHeaderOwnProps } from './IGridWithHeader';

const styles = (theme: any) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '5px 0'
  },
  leftSection: {
    color: theme.palette.primary.main,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 10
  },
  rightSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  showHideColumns: {
    padding: 10,
    borderLeft: `1px solid ${theme.AppBGColor}`
  }
});

interface GridHeaderInjectedProps {
  classes: any;
  userData: any;
}

type GridHeaderProps = GridHeaderOwnProps & GridHeaderInjectedProps;

const GridHeaderComponent: React.FC<GridHeaderProps> = ({
  classes,
  title,
  onSearchTextChange,
  gridApi,
  exportFileName,
  onToggleGridMaximize,
  userData,
  gridHeaderConfig
}) => {
  const exportedFileName = exportFileName || title;
  const {
    showSearchBox = true,
    showShowHideColumns = true,
    showExportCsv = true,
    showFullscreen = true
  } = gridHeaderConfig ?? {};
  return (
    <div className={classes.container}>
      <div className={classes.leftSection}>
        <div>{title}</div>
      </div>
      <div className={classes.rightSection}>
        {showSearchBox && <SearchBox onChange={onSearchTextChange} onEnter={() => {}} />}
        <ClearAllFilterButton gridApi={gridApi} />
        {showShowHideColumns && (
          <div className={classes.showHideColumns}>
            <ShowHideColumns api={gridApi} userData={userData} />
          </div>
        )}
        {showExportCsv && <ExportCsvButton gridApi={gridApi} fileName={exportedFileName} />}
        {showFullscreen && <FullScreen toggleFullscreen={onToggleGridMaximize ?? (() => {})} />}
      </div>
    </div>
  );
};

const GridHeader = withUserProfile(
  withStyles(styles)(GridHeaderComponent as React.ComponentType<GridHeaderProps>)
) as React.ComponentType<GridHeaderOwnProps>;

export default GridHeader;
